import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DoctypeComponent } from '../doctype/doctype.component';
import { ConfirmDeleteAlertComponent } from 'src/app/components/confirm-delete-alert/confirm-delete-alert.component';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

import { FieldsComponent } from '../fields/fields.component';
import { ApiComponent } from '../admin/api/api.component';
import { IonicModule } from '@ionic/angular';
import { UserComponent } from '../admin/user/user.component';
import { TokenViewComponent } from '../tokens/token-view.component';
import { SharesComponent } from '../shares/shares.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { StatsComponent } from '../stats/stats.component';



@NgModule({
  declarations: [
    DoctypeComponent, ConfirmDeleteAlertComponent, HeaderComponent, FieldsComponent, SharesComponent, TokenViewComponent, FooterComponent, ApiComponent, UserComponent, StatsComponent
  ],
  imports: [
    CommonModule, IonicModule, FormsModule, NgxChartsModule
  ],
  exports: [
    DoctypeComponent, ConfirmDeleteAlertComponent, HeaderComponent, FieldsComponent, SharesComponent, TokenViewComponent, FooterComponent, ApiComponent, UserComponent, StatsComponent
  ]
})
export class LoaderModule { }
